import React, { useEffect } from 'react'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { Column } from 'primereact/column'
import { useIntl } from 'react-intl'
import { Group } from '@mantine/core'
import { propsInputNumberCurrency } from '../../../utils/constants/common'
import DataTableComp from '../../common/data-table/DataTableComp'
import { bodyCurrencyInput } from '../../common/data-table/column-types/ColumnTypes'
import CheckboxCom from '../../common/form-components/checkbox/CheckboxComp'
import useAccess from '../../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import './suppliersProposalForm.scss'
import editPriceRowColumn from '../../common/data-table/editors/editPriceRowColumn'

const SupplierPurchaseProposalForm = ({
  dataProposal,
  handleSubmitPrice,
  handleSelectedProvinceSupplier,
  pagerOptions,
}) => {
  const { formatMessage: msg } = useIntl()
  const { canAdd } = useAccess()

  // TODO: Best way to store this custom object?
  const prices = dataProposal?.map((data) => {
    const pricesGOA = data?.pricesList
      ?.filter((price) => price !== null)
      ?.map((price) => {
        return price?.GOA
      })
      .filter((price) => price !== null)
    const pricesG95 = data?.pricesList
      ?.filter((price) => price !== null)
      ?.map((price) => {
        return price?.G95
      })
      .filter((price) => price !== null)
    return {
      province: data?.province,
      GOA: Math.min(...pricesGOA),
      G95: Math.min(...pricesG95),
    }
  })

  const parseValues = () => {
    const parseDataToTable = agruparPorSupplier(dataProposal)
    if (parseDataToTable) {
      const array = Object.entries(parseDataToTable).map(
        ([key, value]) => value,
      )
      return array
    }
    return []
  }

  const agruparPorSupplier = (datos) => {
    return datos?.reduce((grupos, objeto, index) => {
      objeto?.pricesList?.forEach((item) => {
        const supplierId = item?.supplier
        const province = objeto?.province

        if (grupos[supplierId] === undefined) {
          grupos[supplierId] = { supplier: item?.supplierName, supplierId }
        }

        if (grupos[supplierId][province] === undefined) {
          grupos[supplierId][province] = {
            province,
            ...item,
            index,
          }
        }
      })
      return grupos
    }, [])
  }

  const onChangeAndHandleSave = async ({
    supplierId,
    province,
    fuelType,
    value,
  }) => {
    const nuevosPrecios = dataProposal.map((precio) => {
      if (precio.province === province) {
        precio.pricesList.forEach((precioItem) => {
          if (precioItem.supplier === supplierId) {
            precioItem[fuelType] = value
          }
        })
      }
      return precio
    })
    await handleSubmitPrice(nuevosPrecios)
  }

  const editorOptions = canAdd(MODULES.PURCHASE_FUEL, GROUPS.PROPOSAL) &&
    onChangeAndHandleSave && {
      ...editPriceRowColumn({
        propsInput: {
          ...propsInputNumberCurrency,
          minFractionDigits: '3',
          maxFractionDigits: '3',
        },
      }),
    }

  const editCheckbox = (rowData, province, supplierIdSelected, fuelType) => {
    // console.log("editCheckbox", rowData, province, supplierIdSelected, fuelType, rowData[province])
    if (
      rowData?.[province][fuelType] &&
      canAdd(MODULES.PURCHASE_FUEL, GROUPS.PROPOSAL)
    ) {
      return (
        handleSelectedProvinceSupplier && (
          <CheckboxCom
            onChange={() =>
              handleSelectedProvinceSupplier(
                province,
                rowData?.supplierId,
                fuelType,
              )
            }
            checked={supplierIdSelected === rowData?.supplierId}
          />
        )
      )
    }
    return ''
  }

  const onCellEditPriceComplete = (options, province, fuelType) => {
    const { rowData, newValue, originalEvent: event } = options
    if (newValue !== null) {
      onChangeAndHandleSave({
        province,
        supplierId: rowData?.supplierId,
        fuelType,
        value: newValue,
      })
    } else event.preventDefault()
  }

  const bodyPrice = (rowData, gType, province, supplierIdSelected, value) => {
    const className =
      supplierIdSelected === rowData?.supplierId ? 'active-checkbox' : ''
    const minPrice = prices.filter((price) => price.province === province)[0][
      gType
    ]
    const textPriceClassName = value === minPrice ? 'minprice' : ''

    return (
      <div className={`price-badge ${className} ${textPriceClassName}`}>
        {bodyCurrencyInput(value, {
          minFractionDigits: '3',
          maxFractionDigits: '3',
          useGrouping: true,
        })}
      </div>
    )
  }

  const headerColumnGroup = (
    <ColumnGroup>
      <Row key="0">
        <Column header={msg({ id: 'suppliers' })} rowSpan={2} />
        {dataProposal?.map((item) => (
          <Column
            key={`col-0-${item._id}`}
            header={item?.province}
            colSpan={4}
          />
        ))}
      </Row>
      <Row key="1">
        {dataProposal?.map((item) => [
          <Column key={`col-1-${item._id}`} header={msg({ id: 'GOA' })} />,
          <Column key={`col-2-${item._id}`} />,
          <Column key={`col-3-${item._id}`} header={msg({ id: 'G95' })} />,
          <Column key={`col-4-${item._id}`} />,
        ])}
      </Row>
    </ColumnGroup>
  )

  return (
    <Group w="100%" className="proposal-form">
      <DataTableComp
        pagerOptions={pagerOptions}
        tableOptions={{
          value: parseValues(),
          headerColumnGroup,
          size: 'small',
          editMode: 'cell',
        }}
        columns={[
          <Column
            key="supplier-root-0"
            header={msg({ id: 'supplier' })}
            field="supplier"
            style={{ width: '90%', minWidth: '240px' }}
          />,
          dataProposal?.map((item) => [
            <Column
              key={item.id}
              field={`${item?.province}.GOA`}
              {...editorOptions}
              onCellEditComplete={(options) =>
                onCellEditPriceComplete(options, item?.province, 'GOA')
              }
              body={(rowData) =>
                bodyPrice(
                  rowData,
                  'GOA',
                  item?.province,
                  item?.supplierGOASelected,
                  rowData[item?.province]?.GOA,
                )
              }
            />,
            <Column
              key={item.id}
              className="column-bg"
              field={item?.supplierGOASelected}
              body={(rowData) =>
                editCheckbox(
                  rowData,
                  item?.province,
                  item?.supplierGOASelected,
                  'GOA',
                )
              }
            />,
            <Column
              key={item.id}
              field={`${item?.province}.G95`}
              {...editorOptions}
              onCellEditComplete={(options) =>
                onCellEditPriceComplete(options, item?.province, 'G95')
              }
              body={(rowData) =>
                bodyPrice(
                  rowData,
                  'G95',
                  item?.province,
                  item?.supplierG95Selected,
                  rowData[item?.province]?.G95,
                )
              }
            />,
            <Column
              key={item.id}
              className="column-bg"
              field={item?.supplierG95Selected}
              body={(rowData) =>
                editCheckbox(
                  rowData,
                  item?.province,
                  item?.supplierG95Selected,
                  'G95',
                )
              }
            />,
          ]),
        ]}
      />
    </Group>
  )
}

export default SupplierPurchaseProposalForm
